import { TimeOfDayHelper } from "#core/helpers/time-of-day.helper";
import { ProfileModule } from "#core/profile/profile.module";
import { AuthGuardService } from "#guards/auth-guard.service";
import { AutoLoginGuardService } from "#guards/auto-login-guard-service";
import { OAuthGuardService } from "#guards/oauth-guard.service";
import { FormHelper } from "#helpers/form.helper";
import { LoginClassLinkComponent } from "#login/components/login-classlink/login-classlink.component";
import { LoginCleverComponent } from "#login/components/login-clever/login-clever.component";
import { LoginForgotPwdComponent } from "#login/components/login-forgot-pwd/login-forgot-pwd.component";
// components
import { LoginFormComponent } from "#login/components/login-form/login-form.component";
import { LoginOnboardDistrictTeachersComponent } from "#login/components/login-onboard-district-teachers/login-onboard-district-teachers.component";
import { LoginOnboardExistingUserComponent } from "#login/components/login-onboard-existing-user/login-onboard-existing-user.component";
import { LoginOnboardNewUserComponent } from "#login/components/login-onboard-new-user/login-onboard-new-user.component";
import { LoginRegistrationComponent } from "#login/components/login-register/login-registration.component";
import { LoginResetPwdComponent } from "#login/components/login-reset-pwd/login-reset-pwd.component";
import { LoginSampleCenterComponent } from "#login/components/login-sample-center/login-sample-center.component";

import { LoginTempPwdComponent } from "#login/components/login-temp-pwd/login-temp-pwd.component";
import { OauthAuthorizeComponent } from "#login/components/oauth/authorize/oauth-authorize.component";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatStepperModule } from "@angular/material/stepper";
import { MatToolbarModule } from "@angular/material/toolbar";
// services
import { TechCheckService } from "#services/tech-check.service";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EffectsModule } from "@ngrx/effects";
// directives 
import { TrimInputDirective } from "#core/directives/trim-input/trim-input.directive";
// store
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { Auth, DistrictsService, LanguageService, OAuth, ProfileService, StudentsService, SupportService, TeachersService, WelcomeContentService } from "@carnegie-learning/data-access-angular-passport";
import { StoreModule } from "@ngrx/store";
import { LoginRoutingModule } from "./login-routing.module";
import { effects, reducers } from "./store";

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatChipsModule,
        MatFormFieldModule,
        MatIconModule,
        MatStepperModule,
        MatToolbarModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        FlexLayoutModule,
        StoreModule.forFeature("user", reducers),
        EffectsModule.forFeature(effects),
        LoginRoutingModule,
        TrimInputDirective,
        ProfileModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatOptionModule,
        MatTabsModule,
        MatSnackBarModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
    ],
    exports: [LoginRoutingModule],
    declarations: [
        LoginFormComponent,
        LoginRegistrationComponent,
        LoginOnboardNewUserComponent,
        LoginOnboardExistingUserComponent,
        LoginForgotPwdComponent,
        LoginTempPwdComponent,
        LoginCleverComponent,
        OauthAuthorizeComponent,
        LoginClassLinkComponent,
        LoginResetPwdComponent,
        LoginOnboardDistrictTeachersComponent,
        LoginSampleCenterComponent,
    ],
    providers: [
        Auth,
        OAuth,
        ProfileService,
        LanguageService,
        TechCheckService,
        TeachersService,
        SupportService,
        FormHelper,
        AuthGuardService,
        OAuthGuardService,
        AutoLoginGuardService,
        StudentsService,
        DistrictsService,
        WelcomeContentService,
        TimeOfDayHelper,
    ],
    bootstrap: [
        // load components on application load (eg: page load but not main route component)
    ],
})
export class LoginModule {}
